import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Paper, Typography, Slider, Checkbox, TextField, Button, CircularProgress} from "@material-ui/core";
import {CheckCircle, Help, RadioButtonUnchecked} from '@material-ui/icons';
import {createWriteStream} from "streamsaver";
import {INotificacion, IParcela, ISections, IZona} from "../../../types";
import DatePicker, {registerLocale} from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import es from 'date-fns/locale/es';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine} from "recharts";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";
import {resolucion_tablet} from "../../../tools/resolucion";

registerLocale('es', es)


const config = require('../../../config.json');
const texts = require('../../../texts/visualizador.json');

interface IProps {
    setZonas(zonas: number): void
    notify(notification: INotificacion): void
    setPropsZonificacion(props_zonificacion: boolean): void
    openNota(callback: string): void
    menu: boolean
    histograma: Record<string, number>[]
    scale: Record<number, (number | string)[]>
    parcela: IParcela
    loading_zonificador: boolean
    zonificacion_selected: string
    idioma: string
}

interface IState {
    logScale: boolean
    recarga: boolean
    zonas: Record<number, (number[] | string)[]>
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
}

class PropsZonificador extends React.Component<IProps, IState> {
    state: IState = {
        logScale: false,
        recarga: false,
        zonas: {} as Record<number, (number[] | string)[]>,
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        const fuente = this.props.zonificacion_selected.split(',')[0]
        const parcela = this.props.zonificacion_selected.split(',')[1]
        const fecha = this.props.zonificacion_selected.split(',')[2]
        const indice = this.props.zonificacion_selected.split(',')[3]
        const nombre = this.props.zonificacion_selected.split(',')[4]

        axios.get(
            config.url+`/static/visualizador/zonificaciones/${userService.getUser()}/${fuente}/${parcela}/${fecha}/${indice}/${nombre}/info.json`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }}
        )
            .then((res) => {
                this.setState({zonas: res.data as Record<number, (number[] | string)[]>})
            })
            .catch(() => {})
    }

    renderBar = () => {
        if (Object.keys(this.state.zonas).length < 2) return null
        const max: number = this.state.zonas[Object.keys(this.state.zonas).length][1][1] as number
        const min: number = this.state.zonas[1][1][0] as number
        return (
            Object.keys(this.state.zonas).map(i =>
                <div
                    key={Object.keys(this.state.zonas).length-parseInt(i)+1}
                    style={{
                        width: `${100*(this.state.zonas[Object.keys(this.state.zonas).length-parseInt(i)+1][1][1] as number - (this.state.zonas[Object.keys(this.state.zonas).length-parseInt(i)+1][1][0] as number))/(max - min)}%`,
                        height: 10,
                        backgroundColor: this.state.zonas[Object.keys(this.state.zonas).length-parseInt(i)+1][0] as string,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: 'black',
                        borderTopLeftRadius:Object.keys(this.state.zonas).length-parseInt(i)+1 === 1? 6 : 0,
                        borderBottomLeftRadius: Object.keys(this.state.zonas).length-parseInt(i)+1 === 1? 6 : 0,
                        borderTopRightRadius: Object.keys(this.state.zonas).length-parseInt(i)+1 === Object.keys(this.state.zonas).length? 6 : 0,
                        borderBottomRightRadius: Object.keys(this.state.zonas).length-parseInt(i)+1 === Object.keys(this.state.zonas).length? 6 : 0
                    }}
                />
            )
        )
    }

    value = (rango: number, rangos: number[], valores: number[]): number => {
        for (let i=0; i < rangos.length; i++) {
            if (rangos[i] === rango) return valores[i]
        }
        return 0
    }

    render () {

        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false)

        if (Object.keys(this.state.zonas).length < 2) return null
        const muiTheme = createTheme({
            overrides: {
                MuiSlider: {
                    thumb: {
                        color: "white",
                        width: 12,
                        height: 12,
                        borderStyle: "solid",
                        borderWidth:1,
                        borderColor: "black"
                    },
                    rail: {
                        color: "transparent"
                    },
                    track: {
                        color: "transparent"
                    },
                    valueLabel: {
                        top: 22,
                        fontSize: 10,
                        '& *': {
                            background: 'transparent',
                            color: '#000',
                        },
                    },
                }
            }
        });

        const max: number = this.state.zonas[Object.keys(this.state.zonas).length][1][1] as number
        const min: number = this.state.zonas[1][1][0] as number

        const rangos: number[] = []
        const valores: number[] = []
        let i: number = 0
        for (const _i of Object.keys(this.state.zonas)) {
            i = parseInt(_i)
            if (rangos.length === 0) {
                rangos.push(100*(this.state.zonas[i][1][1] as number - (this.state.zonas[i][1][0] as number))/(max-min))
            } else {
                rangos.push(rangos[rangos.length-1] + 100*(this.state.zonas[i][1][1] as number - (this.state.zonas[i][1][0] as number))/(max-min))
            }
            valores.push(this.state.zonas[i][1][1] as number)
        }
        rangos.pop()
        valores.pop()

        return (
            <div
                style={{
                    height: this.state.vertical?
                        resolucion_tablet()? "fit-content": "100%"
                        :
                        resolucion_tablet()? "fit-content": "100%"
                    ,
                    width: this.state.vertical?
                        resolucion_tablet()? '40%': "100%"
                        :
                        resolucion_tablet()? '30%': '40%'
                    ,
                    marginLeft: this.state.vertical?
                        this.props.menu?
                            resolucion_tablet()? '40%' : '0%'
                            :
                            '0%'
                        :
                        this.props.menu?
                            resolucion_tablet()? '30%' : '40%'
                            :
                            60
                    ,
                    marginRight: this.state.vertical?
                        resolucion_tablet()?
                            this.props.menu? '-80%' : '-40%'
                            :
                            "-100%"
                        :
                        this.props.menu?
                            resolucion_tablet()? '-60%': '-80%'
                            :
                            resolucion_tablet()? 'calc(-30% - 60px)' : 'calc(-40% - 60px)'
                    ,
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    zIndex: 300,
                    borderTopRightRadius: 40,
                    borderBottomRightRadius: 40,
                    overflow: "auto",
                    direction: 'rtl'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '90%',
                        height: '100%'
                    }}
                >
                    <Typography
                        style={{
                            marginTop: 40,
                            width: "100%",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: 32,
                            color: '#4b484a',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["4"]}
                    </Typography>

                    <Typography
                        style={{
                            marginTop: 20,
                            width: "100%",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: 16,
                            color: '#4b484a',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["25"]}
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginRight: '10%'
                        }}
                    >
                        {[5, 4, 3, 2].map((element: number) =>
                            <Paper
                                key={element}
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: Object.keys(this.state.zonas).length === element? '#80ED99' : "white",
                                    width: 40,
                                    height: 40,
                                    borderRadius: 20,
                                    marginTop: 10,
                                    cursor: "pointer"
                                }}
                            >
                                {element}
                            </Paper>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            marginTop: 30,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <Help
                            style={{
                                marginRight: 20,
                                marginLeft: 10,
                                cursor: "pointer"
                            }}
                            onClick={() => this.props.openNota(this.state.text["21"])}
                        />
                        <Typography
                            style={{
                                width: "100%",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: 16,
                                color: '#4b484a',
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["26"]}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginRight: '10%',
                            width: '100%',
                            marginTop: 10,
                        }}
                    >
                        <ResponsiveContainer
                            width="100%"
                            height={150}
                        >
                            <AreaChart
                                data={this.props.histograma}
                                margin={{
                                    left: 20,
                                }}
                            >
                                <XAxis dataKey="name" angle={0} dy={5} fontSize={10}/>
                                <YAxis hide={true}/>
                                {!this.state.recarga &&
                                <Area
                                    type="monotone"
                                    dataKey={this.state.logScale? 'log' : 'y'}
                                    stroke="#80ED99"
                                    fill="#80ED99"
                                    strokeWidth={2}
                                    fillOpacity={0.3}
                                />
                                }
                            </AreaChart>
                        </ResponsiveContainer>


                        <div
                            style={{
                                marginTop: 10,
                                width: 'calc(100% - 20px)'
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    height: 12,
                                    zIndex: 100
                                }}
                            >
                                {!this.state.recarga && this.renderBar()}

                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    zIndex: 10,
                                    marginTop: -20
                                }}
                            >
                                <ThemeProvider theme={muiTheme}>
                                    {!this.state.recarga &&
                                    <Slider
                                        min={0}
                                        max={100}
                                        defaultValue={rangos}
                                        value={rangos}
                                        valueLabelDisplay="on"
                                        scale={(x) => {
                                            return this.value(x, rangos, valores)
                                        }}
                                        onChange={(e, v) => {

                                        }}
                                    />
                                    }
                                </ThemeProvider>
                            </div>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '90%',
                                marginTop: 40,
                                marginBottom: 30
                            }}
                        >
                            <Button
                                color={"primary"}
                                variant={"contained"}
                                style={{
                                    textTransform: 'none',
                                    marginRight: 20,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.setPropsZonificacion(false)}
                            >
                                <Typography
                                    style={{
                                        fontSize: 16,
                                        color: '#4b484a',
                                        fontWeight: "bold",
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["27"]}
                                </Typography>
                            </Button>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    menu: state.visualizador.menu,
    histograma: state.visualizador.histograma,
    scale: state.visualizador.scale,
    parcela: state.visualizador.parcela,
    loading_zonificador: state.visualizador.loading_zonificador,
    zonificacion_selected: state.visualizador.zonificacion_selected,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setZonas: (zonas: number) => dispatch({type: "set-visualizador-zonas", zonas}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setPropsZonificacion: (props_zonificacion: boolean) => dispatch({type: "set-visualizador-props-zonificacion", props_zonificacion}),
    openNota: (callback: string) => dispatch({type: "open-nota-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(PropsZonificador);